module.exports = __webpack_public_path__ + "img/14.5e6ee82e.jpg";